import React, { useContext, useState, useEffect } from "react";
import Swiper from "react-id-swiper";
import ImageSliderOneSingle from "../../components/image-slider/ImageSliderOneSingle";
import ImageEditIcon from "../../pages/imageSlider/ImageEditIcon"
import { AuthContext } from "../../common/Auth"

const AutoSlider = ({ imagesList, showButton }) => {

    let showButtonSettings = {}

    if (showButton) {
        showButtonSettings = {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        }
    }

    let settings = {
        loop: false,
        spaceBetween: 10,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        navigation: showButtonSettings,
        breakpoints: {
            992: {
                slidesPerView: 4
            },
            576: {
                slidesPerView: 3
            },
            320: {
                slidesPerView: 1
            }
        }
    }


    return (
        <>

            {settings && (
                <Swiper {...settings}>
                    {Object.keys(imagesList).length > 0 &&
                        imagesList.map((single, key) => {
                            return (
                                <ImageSliderOneSingle
                                    data={single}
                                    key={key}
                                    sliderClass="swiper-slide"
                                />
                            )
                        })}
                </Swiper>
            )}
        </>
    );
};

export default AutoSlider;